export default __webpack_public_path__ + "static/media/hero.310c471d.jpg";